
<template>
  <a-card :bordered="false">
    <component @onEdit="handleEdit" @onGoBack="handleGoBack" @onRecord="handleRecord" :record="record" :is="currentComponet"></component>
  </a-card>
</template>

<script>

import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
// 动态切换组件
import List from '@/views/b-exhibition_commodity/table/List'
import Edit from '@/views/b-exhibition_commodity/table/Edit'
import Record from '@/views/b-exhibition_commodity/table/record'

export default {
  name: 'ExhibitionCommodity',
  components: {
    AInput,
    ATextarea,
    List,
    Edit,
    Record
  },
  data () {
    return {
      currentComponet: 'List',
      record: ''
    }
  },
  created () {

  },
  methods: {
    handleEdit (record) {
      this.record = record || ''
      this.currentComponet = 'Edit'
      console.log(record)
    },
    handleRecord (record) {
      this.record = record || ''
      this.currentComponet = 'Record'
      console.log(record)
    },
    handleGoBack () {
      this.record = ''
      this.currentComponet = 'List'
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
